import type { MotionValue } from 'framer-motion';

import type { DynamicNumber } from './prismTypes';

export function isMotionValue(value: unknown): value is MotionValue<number> {
  return (
    typeof value === 'object' &&
    value != null &&
    typeof (value as MotionValue<number>).get === 'function' &&
    typeof (value as MotionValue<number>).on === 'function'
  );
}

export function readNumber(value: DynamicNumber): number {
  return isMotionValue(value) ? value.get() : value;
}
